import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RelatoriosLayout from "../components/RelatoriosLayout";

const RelatoriosPage = () => {
  return (
    <>
      <MasterLayout>
        <RelatoriosLayout />
      </MasterLayout>
    </>
  );
};

export default RelatoriosPage;
